module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "single-body"
  }, [_c('div', {
    staticClass: "single-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 邀请码 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.invite),
      expression: "addForm.invite"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "邀请码"
    },
    domProps: {
      "value": (_vm.addForm.invite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "invite", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 用户名 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.username),
      expression: "addForm.username"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.addForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 电子邮箱 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.email),
      expression: "addForm.email"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "电子邮箱地址"
    },
    domProps: {
      "value": (_vm.addForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 密码 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.password),
      expression: "addForm.password"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.addForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 密码确认 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.password),
      expression: "addForm.password"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请再次输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.addForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" 验证码 ")]), _vm._v(" "), _c('div', {
    staticClass: "thy-input form-control",
    attrs: {
      "thysize": "lg"
    }
  }, [_c('span', {
    staticClass: "input-label input-label-lg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.validateCode),
      expression: "addForm.validateCode"
    }],
    staticClass: "form-control-lg form-control",
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.addForm.validateCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "validateCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {}, [_c('el-image', {
    attrs: {
      "src": _vm.captcha_url
    },
    on: {
      "click": _vm.get_captcha
    }
  })], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "single-card-actions form-group"
  }, [_c('div', {
    staticClass: "form-group-footer form-group-footer-align-left"
  }, [_c('div', {
    staticClass: "btn-pair form-footer-actions"
  }, [_c('button', {
    staticClass: "btn-block single-btn lg-btn btn btn-primary btn-square",
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v("创建账号\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "single-card-actions-desc"
  }, [_vm._v(" 或 "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleGoBack
    }
  }, [_vm._v("返回登录")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-header"
  }, [_c('a', {
    staticClass: "logo-section",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "datawill-logo-text2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-card-title"
  }, [_c('a', {
    staticClass: "m-5",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "datawill-logo-text2"
  }, [_vm._v("注册用户")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed0a966"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Register.vue
// module id = 271
// module chunks = 1